import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { environment } from 'src/environments/environment';
import { EnvironmentState } from '../reducers/environment.reducer';
import * as selectors from '../selectors/environment.selectors';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentFacadeService extends FacadeService {
  constructor(public override store: Store<EnvironmentState>) {
    super(store);
  }

  // OBSERVABLES
  isProd$ = this.storeSelect(selectors.getProductionStatus);
  account$ = this.storeSelect(selectors.getAccount);

  // OBSERVABLE'S VALUES
  get isProd() {
    return this.storeSnapshot(this.isProd$);
  }

  get account() {
    return this.storeSnapshot(this.account$);
  }

  getEnvironment() {
    if (this.isProd === true) {
      switch (this.account) {
        case 'gdb':
          return `https://${this.account}.inteliqua.net/ci-GDB`;
        case 'intersport':
          return `https://${this.account}.inteliqua.net/ci-Intersport`;
        case 'zakcret':
          return `https://${this.account}.inteliqua.net/ci-Zakcret`;
        case 'vlm':
          return `https://${this.account}.inteliqua.net/ci-VLM`;
        case 'pb':
          return `https://${this.account}.qivos.net/ci-piraeusbank`;
        case 'pbcheckinclass':
          return `https://${this.account}.qivos.net/ci-${this.account}`;
        default:
          return `https://${this.account}.inteliqua.net/ci-${this.account}`;
      }
    } else {
      switch (this.account) {
        case 'vlm':
          return `https://${this.account}.uat.inteliqua.net/ci-VLM-UAT`;
        case 'intersport':
          return `https://${this.account}.uat.inteliqua.net/ci-Intersport-UAT`;
        case 'zakcret':
          return `https://${this.account}.uat.inteliqua.net/ci-Zakcret-UAT`;
        case 'gdb':
          return `https://${this.account}.uat.inteliqua.net/ci-GDB-UAT`;
        case 'pb':
          return `https://${this.account}.uat.qivos.net/ci-piraeusbank-UAT`;
        case 'localhost':
          return `https://${environment.clientName}.uat.inteliqua.net/ci-${environment.clientName}-UAT`;
        case 'hollandandbarrett-fe':
          return `https://${this.account}.uat.inteliqua.net/ci-hollandandbarrett-UAT`;
        case 'vlmjavaupgrade':
          return `https://${this.account}.uat.inteliqua.net/ci-VLM-UAT`;
        case 'stamou-fe':
          return `https://${this.account}.uat.inteliqua.net/ci-stamou-UAT`;
        case 'stamou-fe-crazy':
          return `https://${this.account}.uat.inteliqua.net/ci-stamou-UAT`;
        default:
          return `https://${this.account}.uat.inteliqua.net/ci-${this.account}-UAT`;
      }
    }
  }

  getDomain() {
    let domain: string = '';
    if (this.isProd === true) {
      if (this.account === 'pb' || this.account === 'pbcheckinclass') {
        return (domain = 'qivos');
      } else {
        return (domain = 'inteliqua');
      }
    } else {
      if (this.account === 'pb') {
        return (domain = 'qivos');
      } else {
        return (domain = 'inteliqua');
      }
    }
  }

  IDP() {
    if (this.isProd === true) {
      switch (this.account) {
        case 'protergia':
          return `https://idp.protergia.inteliqua.net`;
        case 'kafd':
          return `https://idp.kafd.qivos.net`;
        case 'pb':
          return `https://idppb.qivos.net`;
        default:
          return `https://idp.inteliqua.net`;
      }
    } else {
      switch (this.account) {
        case 'protergia':
          return `https://idp.uat.protergia.inteliqua.net`;
        case 'kafd':
          return `https://idp.kafd.uat.qivos.net`;
        case 'pb':
          return `https://idppb-uat.qivos.net`;
        default:
          return `https://idp.uat.inteliqua.net`;
      }
    }
  }

  getFeatureFlags() {
    const featureFlags = {
      SMS_BULK: false,
      VIBER_NEW_BULK: false,
    };
    if (this.account === 'notos') {
      featureFlags.SMS_BULK = true;
      featureFlags.VIBER_NEW_BULK = true;
    }

    return featureFlags;
  }
}
